import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFont } from "../../contexts/FontContext/FontContext";
import styles from "./Navbar.module.css";
import Logo from "../../components/Logo/Logo";

const Navbar = ({ resetOption, selectedPage, setSelectedPage }) => {
    const navigate = useNavigate();
    const [animateDefault, setAnimateDefault] = useState(false); // Tracks if default button should animate
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const user = localStorage.getItem("user");
    const fontSchemes = useFont();    
    const fontFamilyOne = fontSchemes.scheme_one; 

    useEffect(() => {
        // Delay the color change for the default "Returns" button on load
        const timer = setTimeout(() => setAnimateDefault(true), 800); // Adjust delay as needed (in ms)
        return () => clearTimeout(timer); // Clean up timer on unmount
    }, []);

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => { window.removeEventListener("resize", handleResize); };
    }, []);

    const handleLogout = () => {
        localStorage.removeItem("authToken");
        sessionStorage.removeItem("shipments");
        navigate("/login");
    };

    const navItems = [
        { id: "returns_button", label: "Returns" },
        { id: "analytics_button", label: "Analytics" },
        { id: "settings_button", label: "Settings" },
    ];

    const handleButtonClick = (label) => { 
        setSelectedPage(label);
        if (label === "Returns") { resetOption(); } // Reset optionSelected to null when "Returns" is clicked
    };

    const handleResize = () => {
		if (window.innerWidth > 750) { setDropdownVisible(false); }
	};

    const getButtonStyle = (label) => ({
        backgroundColor: selectedPage === label && (label !== "Returns" || animateDefault) ? "#6c7c9c" : "",
        color: selectedPage === label && (label !== "Returns" || animateDefault) ? "white" : "",
        transition: "background-color .5s ease, color .5s ease, box-shadow .5s ease", // Slow transition for effect
    });

    const toggleDropdown = () => { setDropdownVisible(prevState => !prevState); };

    return (
        <header className={`${styles.nav_header} ${fontFamilyOne}`}>
        	<div className={styles.navbar_logo_welcome_container}>
                <Logo style={{ top: "0px" }}/>
	            {animateDefault && (
		            <div className={`${styles.welcome_user_container} fade_in`}>	
		            	<p className={styles.welcome_text}> Welcome, </p>
		            	<p className={styles.welcome_user}> {user} </p>
		            </div>
		        )}
		    </div>
            <div className={styles.navbar_right_buttons_container}>
                {navItems.map((item) => (<div key={item.id} className={`${styles.navbar_right_buttons} ${styles[item.id]}`} style={getButtonStyle(item.label)} onClick={() => handleButtonClick(item.label)}>{item.label}</div>))}
                <div className={styles.navbar_toggle_container}>
                    <div className={styles.navbar_toggle_wrapper} onClick={toggleDropdown}>
		                {[...Array(3)].map((_, index) => (<div key={index} className="header_buttons_toggle_lines"></div>))}
		            </div>
		            <div className={`${styles.navbar_right_buttons} ${styles.log_out_button}`} onClick={handleLogout}>Log out</div>
		        </div>
            </div>
            <div className={`${styles.navbar_right_buttons_dropdown}`} style={{ display: dropdownVisible ? "flex" : "none" }}>
                {navItems.map((item) => (<div key={item.id} className={`${styles.navbar_right_dropdown_buttons}`} onClick={() => {handleButtonClick(item.label); toggleDropdown()}}>{item.label}</div>))}
	      	</div>
        </header>
    );
};

export default Navbar;
